export enum ALERTMSG {
  ANERROCCURED = "An error occurred during login. Please try again.",
  APPROVED = "Approved",
  CURRENCY = "Select Currency",
  ERR = "Error",
  INVFILE = "Invalid File Type",
  LOADING = "Please wait...",
  LOGINERR = "Login Error",
  NODATA = "No Data Found",
  SENTFAILED = "Unsuccessful",
  SENTSUCCESS = "Sent Successfully",
  SESSIONEXP = "Session Expired",
  SESSIONEXPMSG = "Session has expired due to an extended amount of time of inactivity.",
  SERVDISRUPTION = "Service Disruption",
  UNDHANDLEDERR = "UNHANDLED ERROR",
  VALIDATED = "Validated Successfully",
  SOMEWENTWRONG = "Something Went Wrong!",
  OOPS = "Oops...",
}
